import {IMSAccountService} from "./ims/IMSAccountService";
import {API_ROOT, FG_URL} from "../config/ApiConfig";
import {getIMSOrgID, mapToQueryString} from "./ApiService";
import {generateRequestHeaders as importedGenerateRequestHeaders } from "./ApiService";

const IMS_CLIENT_ID = 'partnerportal-ui';
const content_type = 'application/x-www-form-urlencoded';

const generateRequestHeaders = () => {
  const accessToken = IMSAccountService.getAccessToken().token

  return {
    'content-type': content_type,
    'x-api-key': IMS_CLIENT_ID,
    'cache-control': 'no-cache',
    'Authorization': `Bearer ${accessToken}`
  };
};

export interface FloodGateResponse {
  analyticsVersion: string;
  api_version: string;
  json_version: string;
  ttl: number;
  caching_enabled: boolean;
  client_analytics_params: {
    app_id: number;
    safe_event_required: boolean;
    analytics_required: boolean;
  };
  releases: Array<{
    params: any;
    bit_index: number;
    release_name: string;
    features: Array<{
      feature: string;
      policy: {
        seed: string;
        hashAlgorithmType: string;
        policyBuckets: Array<{
          start: number;
          end: number;
          variantId: string;
          pureControlGroup: boolean;
        }>;
        previewUserVariantMap: any;
      };
      criteria: string | null;
      hash: string;
      id: number;
      params: {
        cohortingType: string;
      };
      policyId: number;
    }>;
    policy: any;
    criteria: any;
    hash: any;
    policyId: any;
  }>;
}

interface CriteriaCondition {
  operator: 'IN' | 'NOT_IN' | 'EQ' | 'NOT_EQUALS';
  attr: string;
  val: string | string[];
  ruleId?: number;
  category?: string;
}

export async function fetchFeatureFlags(clientId : String): Promise<FloodGateResponse> {
  let queryParams: Map<String, String> = new Map<String, String>();
  queryParams.set('clientId',clientId);
  queryParams.set('CommonOrgID',getIMSOrgID());
  let url = FG_URL + mapToQueryString(queryParams);
  let response = await fetch(url, {
    headers: generateRequestHeaders()
  });
  let data = await response.json();
  data.httpstatus = response.status;
  return data;
}

export function isFeatureEnabledForOrg(featureName: string, response: FloodGateResponse): boolean {
  const orgId = getIMSOrgID();
  const feature = response.releases[0]?.features.find(f => f.feature === featureName);
  
  if (!feature) return false;
  
  // If no criteria, feature is enabled for all
  if (!feature.criteria) return true;
  
  try {
    const criteria = JSON.parse(feature.criteria);
    const conditions = criteria.criteria.and as CriteriaCondition[];
    
    return conditions.every(condition => {
      const { operator, attr, val } = condition;
      
      switch (operator) {
        case 'IN':
          return Array.isArray(val) && val.includes(orgId.toString());
        case 'NOT_IN':
          return Array.isArray(val) && !val.includes(orgId.toString());
        case 'EQ':
          return val === orgId.toString();
        case 'NOT_EQUALS':
          return val !== orgId.toString();
        default:
          console.warn(`Unsupported operator: ${operator} for feature: ${featureName}`);
          return false;
      }
    });
  } catch (error) {
    console.error('Error parsing feature criteria:', error);
    return false;
  }
}

export async function checkOrdersV4Flag(): Promise<boolean> {
  const imsOrgId = getIMSOrgID();
  const url = `${API_ROOT}/ordersv4flag`;

  const response = await fetch(url, {
    method: 'GET',
    headers: importedGenerateRequestHeaders(),
  });

  if (!response.ok) {
    // Optional: log failure or return default
    console.warn(`checkOrdersV4Flag failed with status: ${response.status}`);
    return false;
  }

  const flag = await response.json(); // ✅ parses raw `true` or `false`
  return Boolean(flag); // ensures it's strictly boolean
}



